
//Local 
// export class Constants {
//     Email = "email";
//     Phone = "phone";
//     AuthPortNumber = "9601/";
//     ManageUserPortNumber= "9601/";
//     logOutTime: number = 300;
//     logoutNotificationTime: number = 2000;
//     PermissionPortNumber = "9601/"
//     RolePortNumber = "9601/";
//     ManageOrganizationPortNumber= "9601/"
//     ManageModulePortNumber = "9601/"
//     SettingsPortNumber = "9602/"
//     ManageDocumentPortNumber = "9023/"  //--not used
//     ManageContactsportNumber = "9019/"  // --not used
//     ManageCoreportNumber = "9602/"
//     CustomizedGridComponentPortNumber = "9604/"
//     ManageTranscationportNumber = "9603/" 
//     Chat= "9605/";
//     Edit =  "Edit Permission";
//     Add = "Add Permission";
//     Delete = "Delete Permission";
//     routeArray=[
//         {rolesRoute: "roles"},
//         {userRoute : "users"},
//         {permissionRoute : "permissions"},
//         {organizationRoute : "organization"},
//         {moduleMatserRoute: "moduleMaster"}
//     ]
    
 
//     DropDownField = "Dropdown";
//     CheckboxField = "Checkbox";
//     Image = "Image";
//     URL ="URL";
//     TextArea = "Textarea";
//     Number= "Number";
//     MultiSelect = "MultiSelect";
//     Date = "Date";
//     Currency = "Currency";
//     RadioButton = "RadioButton";
//     TextBox = "Textbox";
//     Address = "Address";
// }


   // - Staging
  // export class Constants {
  //   AuthPortNumber = "https://ecmadminapp-staging.azurewebsites.net/";
  //   ManageUserPortNumber= "https://ecmadminapp-staging.azurewebsites.net/";
  //   PermissionPortNumber = "https://ecmadminapp-staging.azurewebsites.net/";
  //   RolePortNumber = "https://ecmadminapp-staging.azurewebsites.net/";
  //   ManageOrganizationPortNumber= "https://ecmadminapp-staging.azurewebsites.net/";
  //   ManageModulePortNumber = "https://ecmadminapp-staging.azurewebsites.net/";

  //   SettingsPortNumber = "https://ecmsetting-staging.azurewebsites.net/";
  //   ManageCoreportNumber = "https://ecmsetting-staging.azurewebsites.net/";

  //   ManageDocumentPortNumber = "9023";//--Not used
  //   ManageContactsportNumber = "9019/";// -- Not used

  //   CustomizedGridComponentPortNumber = "https://appmanagecustomizedgridcomponentprod-staging.azurewebsites.net/";
  //   ManageTranscationportNumber = "https://appmanagetransactionprod-staging.azurewebsites.net/";
  //   ManageTask = "https://taskschedulingapi-statging.azurewebsites.net/";
  //   Chat= "https://appservicechatprod-staging.azurewebsites.net/"; 
  //   ImportExport="https://importprocessor-staging.azurewebsites.net/";
  //   Edit =  "Edit Permission";
  //   Add = "Add Permission";
  //   Delete = "Delete Permission";
  //   routeArray=[
  //       {rolesRoute: "roles"},
  //       {userRoute : "users"},
  //       {permissionRoute : "permissions"},
  //       {organizationRoute : "organization"},
  //       {moduleMatserRoute: "moduleMaster"}
  //   ]
  //   envProd=false;
  //   Email = "email";
  //   Phone = "phone";
  //   logOutTime: number = 300;
  //  // logoutNotificationTime: number = 3000;
  //   logoutNotificationTime: number = 19000;//1500;
  //   DropDownField = "Dropdown";
  //   CheckboxField = "Checkbox";
  //   Image = "Image";
  //   URL ="URL";
  //   TextArea = "Textarea";
  //   Number= "Number";
  //   MultiSelect = "MultiSelect";
  //   Date = "Date";
  //   Currency = "Currency";
  //   RadioButton = "RadioButton";
  //   TextBox = "Textbox";
  //   Address = "Address";
  // } 

  
 // ── RUNTIME environment detection (2026-09-09) ──────────────────────────────
 // ONE build serves BOTH slots: the API endpoints are chosen at RUNTIME from
 // the host the UI is served on — no more flipping this file before builds.
 //   • ecmuiprod-staging.azurewebsites.net  → STAGING APIs
 //   • localhost / 127.0.0.1 (ng serve dev) → STAGING APIs
 //   • ecmuiprod.azurewebsites.net / custom prod domains → PROD APIs
 const runtimeHost = (typeof window !== 'undefined' && window.location ? window.location.hostname : '').toLowerCase();
 // ── Local-dev overrides (2026-09-18) — ng serve ONLY (host = localhost), set from
 // the browser console, no file edit needed:
 //   localStorage.ecmApiEnv = 'prod'      → talk to the PROD APIs (auth, admin, …)
 //   localStorage.ecmLocalMtApi = '1'     → ManageTransaction API = http://localhost:50115/
 // Remove the keys (or use a normal window) to get the default behaviour back.
 const isLocalHost = runtimeHost === 'localhost' || runtimeHost === '127.0.0.1';
 const devApiEnv = (isLocalHost && typeof localStorage !== 'undefined') ? ((localStorage.getItem('ecmApiEnv') || '').toLowerCase()) : '';
 const useLocalMtApi = isLocalHost && ((typeof localStorage !== 'undefined' && localStorage.getItem('ecmLocalMtApi') === '1')
   || (typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('localMtApi') === '1')); // Explicit local API preview; ignored on hosted UI.
 const useStagingApis = false; //devApiEnv === 'prod' ? false : (runtimeHost.includes('-staging') || isLocalHost);

 // ── Multi-facility referrals rollout flag ─────────────────────────────────
 // MULTIFACILITY_PHASE2 (TRUE since 2026-09-17, client req "activate all actions"):
 // provider pickers in Accept/Decline/status popups (row-level + per-site ⋮
 // preselect from the Recipients panel), placement status line + Closed chip,
 // cross-office resident open/office switch. FALSE = Features 1+2 + Recipients
 // panel + messaging only.
 export const MULTIFACILITY_PHASE2 = true;
 

 // MULTIFACILITY_DEFERRED_ADMISSION — (a) the "Create resident now" checkbox
 // that lets an Accept for THIS office skip the resident form, and (b) the
 // "Create Resident" option on Accepted rows that have no resident yet.
 // Deferred 2026-09-17, ENABLED 2026-09-18 (client req). FALSE would restore
 // the classic accept→resident-form-only flow. NOTE: an Accept sent ONLY on
 // behalf of another facility never creates a resident here regardless of this
 // flag (the resident belongs to that facility's office).
 export const MULTIFACILITY_DEFERRED_ADMISSION = true;
 
 export class Constants {
  AuthPortNumber = useStagingApis ? "https://ecmadminapp-staging.azurewebsites.net/" : "https://ecmadminapp.azurewebsites.net/";
  ManageUserPortNumber= useStagingApis ? "https://ecmadminapp-staging.azurewebsites.net/" : "https://ecmadminapp.azurewebsites.net/";
  PermissionPortNumber = useStagingApis ? "https://ecmadminapp-staging.azurewebsites.net/" : "https://ecmadminapp.azurewebsites.net/";
  RolePortNumber = useStagingApis ? "https://ecmadminapp-staging.azurewebsites.net/" : "https://ecmadminapp.azurewebsites.net/";
  ManageOrganizationPortNumber= useStagingApis ? "https://ecmadminapp-staging.azurewebsites.net/" : "https://ecmadminapp.azurewebsites.net/";
  ManageModulePortNumber = useStagingApis ? "https://ecmadminapp-staging.azurewebsites.net/" : "https://ecmadminapp.azurewebsites.net/";

  SettingsPortNumber = useStagingApis ? "https://ecmsetting-staging.azurewebsites.net/" : "https://ecmsetting.azurewebsites.net/";
  ManageCoreportNumber = useStagingApis ? "https://ecmsetting-staging.azurewebsites.net/" : "https://ecmsetting.azurewebsites.net/";

  ManageDocumentPortNumber = "9023";//--Not used
  ManageContactsportNumber = "9019/";// -- Not used

  CustomizedGridComponentPortNumber = useStagingApis ? "https://appmanagecustomizedgridcomponentprod-staging.azurewebsites.net/" : "https://appmanagecustomizedgridcomponentprod.azurewebsites.net/";
  ManageTranscationportNumber = useLocalMtApi ? "http://localhost:50115/" : (useStagingApis ? "https://appmanagetransactionprod-staging.azurewebsites.net/" : "https://appmanagetransactionprod.azurewebsites.net/");
  ManageTask = useStagingApis ? "https://taskschedulingapi-statging.azurewebsites.net/" : "https://taskschedulingapi.azurewebsites.net/";
  Chat= useStagingApis ? "https://appservicechatprod-staging.azurewebsites.net/" : "https://appservicechatprod.azurewebsites.net/";
  ImportExport= useStagingApis ? "https://importprocessor-staging.azurewebsites.net/" : "https://importprocessor.azurewebsites.net/";
  Edit =  "Edit Permission";
  Add = "Add Permission";
  Delete = "Delete Permission";
  routeArray=[
      {rolesRoute: "roles"},
      {userRoute : "users"},
      {permissionRoute : "permissions"},
      {organizationRoute : "organization"},
      {moduleMatserRoute: "moduleMaster"}
  ] 
  envProd = !useStagingApis;
  Email = "email";
  Phone = "phone";
  logOutTime: number = 300;
  logoutNotificationTime: number = 19000;//1500;
  DropDownField = "Dropdown";
  CheckboxField = "Checkbox";
  Image = "Image";
  URL ="URL";
  TextArea = "Textarea";
  Number= "Number";
  MultiSelect = "MultiSelect";
  Date = "Date";
  Currency = "Currency";
  RadioButton = "RadioButton";
  TextBox = "Textbox";
  Address = "Address";
}


